// Translation dictionaries for EN and DE
// Merged from utils.ts (public translations) and admin.ts (admin translations)

export const translations: Record<string, Record<string, string>> = {
  en: {
    'page-title': 'System Status',
    'system-status': 'System Status',
    'subscribe': 'Subscribe',
    'subscribe-rss': 'RSS Feed',
    'subscribe-atom': 'Atom Feed',
    'subscribe-copied': 'RSS link copied to clipboard',
    'subscribe-copied-rss': 'RSS link copied to clipboard',
    'subscribe-copied-atom': 'Atom link copied to clipboard',
    'status-operational': 'Operational',
    'status-degraded': 'Degraded',
    'status-partial': 'Partial Outage',
    'status-major': 'Major Outage',
    'filter-placeholder': 'Filter by text, type, status…',
    'service-label': 'Service:',
    'service-label-plain': 'Service',
    'component-label': 'Component:',
    'component-optional-label': 'Component (optional)',
    'time-label': 'Time:',
    'type-label': 'Type',
    'severity-label': 'Severity',
    'status-label': 'Status',
    'start-label': 'Start',
    'end-label': 'End (optional)',
    'title-label': 'Title',
    'summary-label': 'Summary',
    'details-label': 'Details',
    'details-optional-label': 'Details (optional)',
    'updates-label': 'Updates',
    'add-update': '+ Add update',
    'none': 'None',
    'new-event': 'New Event',
    'edit-event': 'Edit Event',
    'loading': 'Loading...',
    'last-updated': 'Last updated:',
    'admin-login': 'Sign in',
    'admin-logout': 'Sign out',
    'ongoing': 'ongoing',
    'never': 'never',
    'no-results': 'No status updates found.',
    'toggle-sort-order': 'Toggle sort order',
    'system-status-detail': 'System Status Details',
    'affected-services': 'Affected Services & Components',
    'all-systems-operational': 'All systems operational',
    'subscribe-email-modal-title': 'Subscribe to updates',
    'subscribe-email-address': 'Email Address',
    'subscribe-email-placeholder': 'your@email.com',
    'subscribe-services': 'Services',
    'subscribe-severities': 'Severities',
    'subscribe-select-services': 'Select services to monitor',
    'subscribe-select-severities': 'Select severity levels to be notified about',
    'subscribe-tab-email': 'Email',
    'subscribe-tab-feeds': 'Feeds',
    'subscribe-tab-slack': 'Slack',
    'subscribe-submit': 'Subscribe',
    'subscribe-slack-instructions': 'To receive live status updates in Slack, copy and paste the command below into the Slack channel of your choice.',
    'subscribe-slack-command-label': 'Slack command',
    'subscribe-slack-command-aria': 'Slack subscription command',
    'subscribe-subscribed': 'Subscribed',
    'subscribe-success': 'Subscription successful! Please check your inbox to confirm.',
    'subscribe-error': 'Subscription failed. Please try again.',
    'subscribe-feed-links': 'Or subscribe via RSS/Atom feed',
    'subscribe-get-rss': 'Get the RSS feed',
    'subscribe-get-atom': 'Get the Atom feed',
    'subscribe-copy': 'Copy',
    'subscribe-copied-short': 'Copied',
    'subscribe-email-invalid': 'Please enter a valid email address',
    'subscribe-email-required': 'Email address is required',
    'subscribe-services-required': 'Please select at least one service.',
    'subscribe-confirmed': 'Email confirmed! You will now receive status updates.',
    'subscribe-already-verified': 'Email address already verified',
    'subscribe-privacy-agree': 'I have read and agree to the <a href="#" class="modal-link privacy-link">Data Privacy Statement</a>',
    'subscribe-privacy-prefix': 'I have read and agree to the',
    'subscribe-privacy-suffix': '',
    'unsubscribe-success': 'You have been unsubscribed successfully.',
    'unsubscribe-error': 'Unsubscribe failed. Please try again.',
    'preferences-title': 'Update Preferences',
    'preferences-info': 'Update your notification preferences below.',
    'preferences-email-label': 'Email:',
    'preferences-save': 'Save Changes',
    'preferences-updated': 'Your preferences have been updated.',
    'preferences-error': 'Could not load preferences. The link may have expired.',
    'notifications': 'Notifications',
    'notifications-title': 'Recent Notifications',
    'notifications-empty': 'No notifications yet.',
    'admin-publish': 'Publish',
    'admin-published': 'Published',
    'admin-republish': 'Re-publish',
    'admin-delete': 'Delete',
    'admin-delete-disabled': 'Cannot delete published events',
    'admin-sending-notifications': 'Sending notifications…',
    'admin-sent': 'Sent',
    'admin-of': 'of',
    'admin-emails': 'emails',
    'data-privacy': 'Data Privacy',
    'data-privacy-button': 'Data Privacy',
    'data-privacy-modal-title': 'Data Privacy Statement',
    'data-privacy-close': 'Close',
    // Admin-specific
    'publish-modal-title': 'Confirm Publish',
    'publish-modal-text-prefix': 'This will notify',
    'publish-modal-text-suffix': 'subscribers. Proceed?',
    'publish-confirm': 'Publish',
    'preview-send-btn': 'Send to me only',
    'preview-send-success': 'Preview email sent successfully!',
    'cancel': 'Cancel',
    'publish-success': 'Event published successfully!',
    'unpublished': 'Unpublished',
    'edited': 'Edited',
    'permalink-copied': 'Permalink copied to clipboard',
  },
  de: {
    'page-title': 'Systemstatus',
    'system-status': 'Systemstatus',
    'subscribe': 'Abonnieren',
    'subscribe-rss': 'RSS-Feed',
    'subscribe-atom': 'Atom-Feed',
    'subscribe-copied': 'RSS-Link in die Zwischenablage kopiert',
    'subscribe-copied-rss': 'RSS-Link in die Zwischenablage kopiert',
    'subscribe-copied-atom': 'Atom-Link in die Zwischenablage kopiert',
    'status-operational': 'Verfügbar',
    'status-degraded': 'Beeinträchtigt',
    'status-partial': 'Teilweiser Ausfall',
    'status-major': 'Schwerwiegender Ausfall',
    'filter-placeholder': 'Nach Text, Typ, Status filtern…',
    'service-label': 'Dienst:',
    'service-label-plain': 'Dienst',
    'component-label': 'Komponente:',
    'component-optional-label': 'Komponente (optional)',
    'time-label': 'Zeit:',
    'type-label': 'Typ',
    'severity-label': 'Auswirkung',
    'status-label': 'Status',
    'start-label': 'Start',
    'end-label': 'Ende (optional)',
    'title-label': 'Titel',
    'summary-label': 'Zusammenfassung',
    'details-label': 'Details',
    'details-optional-label': 'Details (optional)',
    'updates-label': 'Aktualisierungen',
    'add-update': '+ Update hinzufügen',
    'none': 'Keine',
    'new-event': 'Neues Ereignis',
    'edit-event': 'Ereignis bearbeiten',
    'loading': 'Wird geladen...',
    'last-updated': 'Zuletzt aktualisiert:',
    'admin-login': 'Anmelden',
    'admin-logout': 'Abmelden',
    'ongoing': 'laufend',
    'never': 'nie',
    'no-results': 'Keine Statusaktualisierungen gefunden.',
    'toggle-sort-order': 'Sortierreihenfolge umkehren',
    'system-status-detail': 'Systemstatus-Details',
    'affected-services': 'Betroffene Dienste & Komponenten',
    'all-systems-operational': 'Alle Systeme verfügbar',
    'subscribe-email-modal-title': 'Updates abonnieren',
    'subscribe-email-address': 'E-Mail-Adresse',
    'subscribe-email-placeholder': 'deine@email.de',
    'subscribe-services': 'Dienste',
    'subscribe-severities': 'Auswirkung',
    'subscribe-select-services': 'Dienste auswählen, die überwacht werden sollen',
    'subscribe-select-severities': 'Auswirkung auswählen, für die Sie benachrichtigt werden möchten',
    'subscribe-tab-email': 'E-Mail',
    'subscribe-tab-feeds': 'Feeds',
    'subscribe-tab-slack': 'Slack',
    'subscribe-submit': 'Anmeldung',
    'subscribe-slack-instructions': 'Um Live-Statusupdates in Slack zu erhalten, kopiere den Befehl unten und füge ihn in den gewünschten Slack-Channel ein.',
    'subscribe-slack-command-label': 'Slack-Befehl',
    'subscribe-slack-command-aria': 'Slack-Abonnementbefehl',
    'subscribe-subscribed': 'Angemeldet',
    'subscribe-success': 'Anmeldung erfolgreich! Bitte überprüfen Sie Ihren Posteingang zur Bestätigung.',
    'subscribe-error': 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'subscribe-feed-links': 'Oder abonnieren Sie über RSS/Atom-Feed',
    'subscribe-get-rss': 'RSS-Feed abrufen',
    'subscribe-get-atom': 'Atom-Feed abrufen',
    'subscribe-copy': 'Kopieren',
    'subscribe-copied-short': 'Kopiert',
    'subscribe-email-invalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    'subscribe-email-required': 'E-Mail-Adresse ist erforderlich',
    'subscribe-services-required': 'Bitte wählen Sie mindestens einen Dienst aus.',
    'subscribe-confirmed': 'E-Mail bestätigt! Sie erhalten ab jetzt Statusaktualisierungen.',
    'subscribe-already-verified': 'E-Mail-Adresse bereits verifiziert',
    'subscribe-privacy-agree': 'Ich habe die <a href="#" class="modal-link privacy-link">Datenschutzerklärung</a> gelesen und stimme dieser zu',
    'subscribe-privacy-prefix': 'Ich habe die',
    'subscribe-privacy-suffix': 'gelesen und stimme dieser zu',
    'unsubscribe-success': 'Sie haben sich erfolgreich abgemeldet.',
    'unsubscribe-error': 'Abmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'preferences-title': 'Einstellungen ändern',
    'preferences-info': 'Aktualisieren Sie Ihre Benachrichtigungseinstellungen.',
    'preferences-email-label': 'E-Mail:',
    'preferences-save': 'Änderungen speichern',
    'preferences-updated': 'Ihre Einstellungen wurden aktualisiert.',
    'preferences-error': 'Einstellungen konnten nicht geladen werden. Der Link ist möglicherweise abgelaufen.',
    'notifications': 'Benachrichtigungen',
    'notifications-title': 'Letzte Benachrichtigungen',
    'notifications-empty': 'Noch keine Benachrichtigungen.',
    'admin-publish': 'Veröffentlichen',
    'admin-published': 'Veröffentlicht',
    'admin-republish': 'Erneut veröffentlichen',
    'admin-delete': 'Löschen',
    'admin-delete-disabled': 'Veröffentlichte Ereignisse können nicht gelöscht werden',
    'admin-sending-notifications': 'Benachrichtigungen werden gesendet…',
    'admin-sent': 'Gesendet',
    'admin-of': 'von',
    'admin-emails': 'E-Mails',
    'data-privacy': 'Datenschutzerklärung',
    'data-privacy-button': 'Datenschutzerklärung',
    'data-privacy-modal-title': 'Datenschutzerklärung',
    'data-privacy-close': 'Schließen',
    // Admin-specific
    'publish-modal-title': 'Veröffentlichung bestätigen',
    'publish-modal-text-prefix': 'Dies wird',
    'publish-modal-text-suffix': 'Abonnenten benachrichtigen. Fortfahren?',
    'publish-confirm': 'Veröffentlichen',
    'preview-send-btn': 'Nur an mich senden',
    'preview-send-success': 'Vorschau-E-Mail erfolgreich versendet!',
    'cancel': 'Abbrechen',
    'publish-success': 'Ereignis erfolgreich veröffentlicht!',
    'unpublished': 'Unveröffentlicht',
    'edited': 'Bearbeitet',
    'permalink-copied': 'Permalink in die Zwischenablage kopiert',
  },
}

export const severityLabels: Record<string, Record<string, string>> = {
  en: { info: 'Info', minor: 'Minor', major: 'Major', critical: 'Critical' },
  de: { info: 'Info', minor: 'Gering', major: 'Wichtig', critical: 'Kritisch' },
}

export const typeLabels: Record<string, Record<string, string>> = {
  en: { incident: 'Incident', maintenance: 'Maintenance', info: 'Info' },
  de: { incident: 'Störung', maintenance: 'Wartung', info: 'Info' },
}

export const statusLabels: Record<string, Record<string, string>> = {
  en: {
    investigating: 'Investigating',
    identified: 'Identified',
    monitoring: 'Monitoring',
    resolved: 'Resolved',
    scheduled: 'Scheduled',
    in_progress: 'In Progress',
    completed: 'Completed',
    canceled: 'Canceled',
    published: 'Published',
    updated: 'Updated',
    archived: 'Archived',
  },
  de: {
    investigating: 'Wird untersucht',
    identified: 'Ermittelt',
    monitoring: 'Wird überwacht',
    resolved: 'Gelöst',
    scheduled: 'Geplant',
    in_progress: 'Läuft',
    completed: 'Abgeschlossen',
    canceled: 'Abgebrochen',
    published: 'Veröffentlicht',
    updated: 'Aktualisiert',
    archived: 'Archiviert',
  },
}

export const scopeLabels: Record<string, Record<string, string>> = {
  en: {
    Infrastructure: 'Infrastructure',
    'Shared Hosting': 'Shared Hosting',
    General: 'General',
  },
  de: {
    Infrastructure: 'Infrastruktur',
    'Shared Hosting': 'Shared Hosting',
    General: 'Allgemein',
  },
}
